import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'

@Module({ namespaced: true, name: 'browser' })
export default class ModuleBrowser extends VuexModule {

    geolocation = {
        watchId: 0,
        coordinates: {
            latitude: 0,
            longitude: 0
        }
    }

    @Mutation
    storeGeolocationWatchId(watchId: number) {
        this.geolocation.watchId = watchId
    }

    @Mutation
    storeGeolocationCoordinates(coordinates: any) {
        this.geolocation.coordinates = coordinates
    }

    @Action({ commit: 'storeGeolocationWatchId' })
    geolocationWatch() {
        const watchId = navigator.geolocation.watchPosition((position) => {

            this.context.commit('storeGeolocationCoordinates', {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
            })

        }, () => this.context.commit('root/snackbar', 'Location capture disabled', { root: true }), { enableHighAccuracy: true })

        return watchId
    }

    @Action({ commit: 'storeGeolocationWatchId' })
    geolocationClearWatch() {
        navigator.geolocation.clearWatch(this.geolocation.watchId)
        return 0
    }
}